const isEllipsisActive = element => (element ? element.offsetWidth < element.scrollWidth : false);

export default isEllipsisActive;
